import get from 'lodash.get';
import { createSelector } from 'reselect';

export const selectProductCategories = createSelector(
  ({ productCategories } = {}) => productCategories,
  (productCategories) => {
    return productCategories ? Object.keys(productCategories).reduce((acc, index) => [...acc, productCategories[index]], []) : [];
  },
);

const selectProductCategoryById = ({ productCategories }, props) => get(productCategories, props.categoryId);
export const selectProductCategoryPropertyById = (state, props) => get(selectProductCategoryById(state, props), props.property);
